<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div>
    <div class="scrollable-mode">
      <el-switch
        v-if="!allValueZero"
        v-model="scrollableMode"
        :disabled="columnChartData.traceData[0].x.length == 1"
        @change="handleScrollableMode"
        active-text="scroll chart">
      </el-switch>
    </div>
    <div class="view-by-column">View by {{this.type}}</div>
    <div ref="chart" class="wy-panel-line-column-chart" :id="chartId">
    </div>

    <div ref="hoverChart" id='hoverinfo-line'>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import WyUtils from '../../../library/wy-utils.js';
import WyChartModule from '../../../library/wy-chart-module.js';
import WyChartUtils from '../utils/wy-chart-util.js';
import WyPanelUtils from '../../../components/panel-views/utils/wy-panel-util.js';

export default Vue.extend({
  name: 'wy-panel-line-column-chart',
  props: ['controller', 'chartId', 'lineChartData', 'columnChartData', 'tabBottomSection', 'type', 'legendColors'],

  data() {
    return {
      module: this,
      scrollableMode: false,
      allValueZero: true,
      loading: false,
      tickformat: '%b %Y',
      localData: null,
      hasRegressionData: true,
      hasComboLineData: true,
      localLayout: null,
      localChart: null
    }
  },
  methods: {
    handleDateChange(type){
      if(type == 'year'){
        this.tickformat = '%Y'
      } else if (type == 'quarter'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'week'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'day'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'month'){
        this.tickformat = '%b %Y'
      }
    },

    toggleLegend(legendsData) {
      let mapLagends = WyPanelUtils.mapLagends;
      this.localData = JSON.parse(JSON.stringify(this.columnChartData));
      let showTraceList = []
      this.hasRegressionData = true;
      this.hasComboLineData = true;
      this.localData.traceData.forEach((traceData) => {
      legendsData.forEach(legendObj => {
          if(legendObj.toggle && (mapLagends[traceData.key] == legendObj.legend || traceData.key == legendObj.legend) && legendObj.legend != 'regression') {
            showTraceList.push(traceData)
          }
          if(!legendObj.toggle && legendObj.legend == 'regression') {
            this.hasRegressionData = false
          }
          if(!legendObj.toggle && legendObj.comboLine) {
            this.hasComboLineData = false
          }
        })
      })
      this.localData.traceData = showTraceList;
      this.buildChart('legend');
    },

    handleScrollableMode() {
      this.buildChart('scrollable')
    },
    buildTooltip(point, data) {
      const pointX = point.bbox.x1;  
      const pointY = point.bbox.y1;
      const pointIndex = point.pointIndex;

      data.forEach((item) => {
        this.tabBottomSection.legendsData.forEach(legendObj => {
          if(item.marker && item.marker.color == legendObj.color) {
            item.legend = legendObj.legend
          }
        })
      })
      
      let localData = JSON.parse(JSON.stringify(data));
      let colors = [];
      localData.forEach(el => {
        if(el.marker){
          colors.push(el.marker.color)
        }
      });

      let values = [];
      localData.forEach(el => {
        values.push(el.y[pointIndex]);
      });
      
      let labels = [];
      localData.forEach(el => labels.push(el.legend));

      if(values.length == localData.length && labels[labels.length - 1] == undefined && labels[labels.length - 2] == undefined){
        labels[labels.length - 2] = localData[localData.length - 2].key
        labels[labels.length - 1] = localData[localData.length - 1].key
      }

      if(values[values.length - 2] == null){
        values.splice(values.length - 2, 1)
        labels.splice(labels.length - 2, 1)
      }
      else if(labels[labels.length - 1] == undefined && values.length == localData.length && !values.includes(null)){
        labels[labels.length - 1] = localData[localData.length - 1].key
      }
      else if(labels.length == 2 && labels[labels.length - 1] == undefined && values[values.length - 1] == null){
        values.splice(values.length - 1, 1)
        labels.splice(labels.length - 1, 1)
      } else if((labels[labels.length - 1] == undefined && values[values.length - 1] == null)){
        values.splice(values.length - 1, 1)
        labels.splice(labels.length - 1, 1)
      }

      let sum = 0;
      let valuesWithoutRegresssion = [];
      if(labels.includes('regression') && labels.includes('time')){
        valuesWithoutRegresssion = values.splice(values.length - 2, 2)
      }
      for(let i = 0; i < labels.length; i++){
        if(labels[i].includes('time')){
          valuesWithoutRegresssion = values.slice(0, i)
        }
        else {
          valuesWithoutRegresssion = values;
        }
      }
      if(labels.includes('regression') && !labels.includes('time')){
        valuesWithoutRegresssion = values.slice(0, labels.length - 1)
      }
      
      valuesWithoutRegresssion.forEach(num => sum += num);


      let pointDate = "";
      if(data[0].z && data[0].z.length > 0) {
        pointDate = data[0].z[pointIndex];
      }
      else {
        if(this.type == 'day') {
          pointDate = moment(data[0].x[pointIndex]).format("MMM DD YYYY");
        }
        else {
          pointDate = data[0].x[pointIndex];
        }
      }
      

      const labelHtml = labels.map((p, idx) => {
        
      return `<div style="display:flex;">
                  <div class="${p == 'regression'? 'regression-marker':'dx-tooltip-pipe'}" style="background-color: ${colors[idx]}">
                  </div>
                  <div class="dx-tooltip-label" style="font-weight: 400; display: flex; flex-direction: column">
                      <div class="tooltip-legendtext-label">${p}</div>
                      <div class="tooltip-legendtext-num">${p == undefined ? '' : p.includes('time')? WyUtils.toNiceTimeFormatFromMinus(values[idx]) : values[idx] == null? '0.0' : values[idx].toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ${p === 'regression'|| p.includes('time')? ' ': valuesWithoutRegresssion[idx] == 0? "(0.0%)" :'(' + ((valuesWithoutRegresssion[idx]/sum) * 100).toFixed(1) + '%)'}</div>
                  </div>
                </div>`;
      }).join('');

      const html = ` <div class="dx-tooltip tooltip-bg" style="left: ${pointX + 15}px; top:${pointY - 50}px">
                        <div style="pointer-events: none;">
                            <div class="tooltip-legendtitletext" style="text-align:center">${pointDate}</div>
                        </div>
                        <div>
                            ${labelHtml}
                        </div>
                    </div>`;
      return html;
    },
    buildChart(mode) {
      setTimeout(()=>{
        const wyChart = new WyChartModule();
        if(!mode) {
          this.localData = JSON.parse(JSON.stringify(this.columnChartData));
          this.hasRegressionData = true;
          this.hasComboLineData = true;
        }
        let yTotal = [];
        this.localData.traceData[0].y.forEach((item)=>{
          yTotal.push(item)
        });
        this.localData.traceData.forEach((item, index) => {
          if(index > 0) {
            item.y.forEach((yValue, valIndex) => {
              yTotal[valIndex] = yTotal[valIndex] + yValue
            })
          }
        })
        this.allValueZero = true;
        yTotal.forEach(yVal => {
          if(yVal != 0) {
            this.allValueZero = false;
          }
        })
        const median = wyChart.prepareRegressionDataByTrace({x: this.localData.traceData[0].x, y: yTotal}, {});
        let traceRegression = {
          name: '',
          type: 'scatter',
          mode: "lines",
          key: 'regression',
          x: median.regressionData.xValues,
          y: median.regressionData.yValues,
          showlegend: false,
          fill: 'none',
          line: {
            dash: 'dot',
            color: '#0A0B37',
            width: 1.5
          },          
        };

        let colors = [];
        this.lineChartData.xAxisData.forEach(() => {
          colors.push('transparent');
        });
        // this.lineChartData.yAxisData = [902, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1.29, 1.46, 1.25, 1.6, 1.81, 1.38, 1.54]
        var traceLineData = {
          x: this.lineChartData.xAxisData,
          y: JSON.parse(JSON.stringify(this.lineChartData.yAxisData)),
          name:'',
          type: 'scatter',
          key: this.lineChartData.title,
          mode: "lines+markers",
          cliponaxis: false,
          marker: {color: colors, size: 8},
          fill: 'none',
          line: {
            color: '#0C2837',
            width: 2
          },
          yaxis: {},    
        };
        if(this.controller.controller.panelId == 'liveAgentHandling') {
          let toolTipsList = [];
          this.lineChartData.yAxisData.forEach(val=>{
            toolTipsList.push(WyUtils.toNiceTimeFormat(val * 60))
          })
        }
        let layout = {
          barmode: 'stack',
          margin: { l: 40, r: 70, t: 10, b: 10, pad: 10},
          autoexpand: true,
          autosize: true,
          height: 300,
          hovermode: 'x',
          bargap: 0.2,
          dragmode: false,
          showlegend: false,      
          legend: {
              orientation: 'h',
              x: 0.11,
              y: -0.3
          },
          xaxis:  {
            autorange: true,
            fixedrange: true,
            showgrid: false,
            // automargin: true,
            showline: true,
            tickformat: this.tickformat,
            linecolor: 'transparent',
            tickangle: 0,
            rangeslider: {autorange: true}
          },
          yaxis: {
            name: 'y2',
            title: {
              text: this.localData.title,
              font: {
                family: 'Helvetica Neue", Helvetica, Arial, sans-serif',
                size: 11
              }
            },
            titlefont: {color: '#0C2837'},
            tickfont: {color: '#0C2837'},
            side: 'right',
            // position: 0.15
          },

          yaxis2: {
            name: 'y1',
            title: {
              text: this.lineChartData.title,
              font: {
                family: 'Helvetica Neue", Helvetica, Arial, sans-serif',
                size: 11
              }
            },
            titlefont: {color: '#0C2837'},
            tickfont: {color: '#0C2837'},
            anchor: 'free',
            overlaying: 'y',
            side: 'left',
            // position: 0,
            rangemode: 'tozero',
            autosize: true,
            fixedrange: true,
            font: {
              family: 'Helvetica Neue", Helvetica, Arial, sans-serif',
              size: 11
            }
          },
          yaxis3: {
            name: 'y3',
            title: '',
            titlefont: {color: 'transparent'},
            tickfont: {color: 'transparent'},
            anchor: 'free',
            overlaying: 'y',
            side: 'left',
            position: 0,
            rangemode: 'nonnegative',
            autosize: true,
            fixedrange: true
          }
        }

        let xLength = this.localData.traceData[0].x.length;
        if(!mode) {
          if(xLength < 20 || this.allValueZero) {
            this.scrollableMode = false;
          }
          else {
            this.scrollableMode = true;
          }
        }
        // traces.forEach(trace => {
        //   if(trace && Array.isArray(trace.y) && trace.y.length > 0) {
        //     let maxValue = trace.y.reduce((max, val) => {
        //       return (val > max) ? val : max;
        //     })
        //     if(maxValue > yAxisMaxValue) {
        //       yAxisMaxValue = maxValue;
        //     }
        //   }
        // });
        // if(maxYValue) {
        //   layout.yaxis.autorange = false;
        //   layout.yaxis.range = [0, maxYValue];
        // }
        
        // if(suffix == '%') {
        //   layout.yaxis.autorange = false;
        //   layout.yaxis.range = (layout.yaxis.rangePercent ? layout.yaxis.rangePercent : [0, 100]);
        // }
        // else if(suffix == 'm' && yAxisMaxValue < 1) {
        //   layout.yaxis.autorange = false;
        //   layout.yaxis.range = (layout.yaxis.rangeSecond ? layout.yaxis.rangeSecond : [0, 60]);
        //   layout.yaxis.ticksuffix = 's ';
        // }
        // else if(yAxisMaxValue < 5) {
        //   layout.yaxis.autorange = false;
        //   layout.yaxis.range = [0, 5];
        // }
        if(this.lineChartData.suffix == 'm') {
          layout.yaxis2.ticksuffix = 'm';
        }
        let yAxisMaxValue = 0;
        this.lineChartData.yAxisData.forEach(yData => {
          if(yData && Array.isArray(yData) && yData.length > 0) {
            let maxValue = yData.reduce((max, val) => {
              return (val > max) ? val : max;
            })
            if(maxValue > yAxisMaxValue) {
              yAxisMaxValue = maxValue;
            }
          }
        });
        if(yAxisMaxValue) {
          traceLineData.yaxis.autorange = false;
          traceLineData.yaxis.range = [0, yAxisMaxValue];
        }

        if(this.lineChartData.suffix == 'm' && yAxisMaxValue < 1) {
          traceLineData.yaxis.autorange = false;
          traceLineData.yaxis.range = (layout.yaxis.rangeSecond ? layout.yaxis.rangeSecond : [0, 60]);
          traceLineData.yaxis.ticksuffix = 's';
        }

        if(this.type) {
          this.handleDateChange(this.type)
        }
        //line chart logic
        if(this.lineChartData.suffix == '%') {
          layout.yaxis2.range = [0, 100];
          layout.yaxis2.ticksuffix = '%';
        }

        if(this.lineChartData.xAxisData.length > 1 && this.lineChartData.xAxisData.length < 5) {
          layout.xaxis.nticks = this.lineChartData.xAxisData.length;
          layout.xaxis.tickformat = this.tickformat;
          if(this.type == 'year') {
            layout.xaxis.tickformat = null;
          }
        }
        if(this.lineChartData.xAxisData.length == 1) {
          layout.xaxis.nticks = 3;
          // traceLineData.marker.color = this.legendColors[this.localData.traceData.length];
          traceLineData.marker.color = '#0C2837';
        } 
        if(this.lineChartData.xAxisData.length < 5) {
          layout.xaxis.nticks = this.lineChartData.xAxisData.length;
        }

        if(this.lineChartData.xAxisData.length >= 5 && this.lineChartData.xAxisData.length < 10) {
          layout.xaxis.nticks = 5;
          layout.xaxis.tickformat = this.tickformat;
        }
        if(this.lineChartData.xAxisData.length >= 10) {
          if(!this.scrollableMode) {
            layout.xaxis.tickmode = 'array';
            layout.xaxis.tickvals = [this.lineChartData.xAxisData[0], this.lineChartData.xAxisData[Math.round((this.lineChartData.xAxisData.length - 1)/2)], this.lineChartData.xAxisData[this.lineChartData.xAxisData.length-1]]
          }
          layout.xaxis.nticks = 3;
          layout.xaxis.tickformat = this.tickformat;
        }
        
        if(xLength > 1 && xLength < 5) {
          layout.xaxis.nticks = xLength + 1;
          if(this.type == 'year') {
            layout.xaxis.tickformat = null;
          }
        }
        else {
          if(xLength == 1) {
            layout.xaxis.nticks = 2;
            layout.xaxis.tickformat = null;
            this.localData.traceData.forEach(trace=>{
              trace.width = 0.4
            })
          }
          else {
            this.localData.traceData.forEach(trace=>{
              if(!this.scrollableMode) {
                layout.xaxis.tickmode = 'array';
                layout.xaxis.tickvals = [trace.x[0], trace.x[Math.round((xLength - 1)/2)], trace.x[xLength - 1]]
              }
              layout.xaxis.nticks = 3;
              layout.xaxis.tickformat = this.tickformat;
              trace.width = null
            })
          }
        }
        let data = [];
        this.localData.traceData.forEach(traceBar => {
          traceBar.yaxis = 'y1';
          data.push(traceBar);
        })
        traceLineData.yaxis = 'y2'
        if(!this.hasComboLineData) {
          // traceLineData.y = [];
          for(let i=0; i<traceLineData.y.length; i++) {
            traceLineData.y[i] = null
          }
          layout.yaxis2.titlefont.color = 'transparent';
          layout.yaxis2.tickfont.color = 'transparent'; 
          layout.yaxis2.title.font.color = 'transparent';
        }
        data.push(traceLineData);

        traceRegression.yaxis = 'y1'
        if(this.hasRegressionData) {
          data.push(traceRegression);
        }

        let config = {responsive: true, displayModeBar: false, scrollZoom: false, showTips: false};
        // setTimeout(()=>{
        //   var d3 = Plotly.d3;
        //   d3.select('g.draglayer').selectAll('rect').style('cursor', 'pointer');
        // },1000)
        
        if(this.type == 'day') {
          WyChartUtils.scrollableChartSetLayoutByDay(this.localData.traceData[0].x, xLength, layout)
        }
        if(this.type == 'week') {
          WyChartUtils.scrollableChartSetLayoutByWeek(xLength, layout)
        }
        if(this.type == 'month') {
          WyChartUtils.scrollableChartSetLayoutByMonth(xLength, layout)
        }
        if(this.type == 'year') {
          WyChartUtils.scrollableChartSetLayoutByYear(xLength, layout)
        }
        if(!this.scrollableMode) {
          layout.xaxis.autorange = true;
          layout.xaxis.automargin = true;
          layout.xaxis.rangeslider = null; 
        }
        else {
          layout.xaxis.autorange = false;
          layout.xaxis.automargin = null;
          layout.xaxis.rangeslider = {autorange: true, thickness: 0.1}
        }
        if(!mode || mode != 'legend') {
          // if(!this.hasComboLineData) {
          //   layout.hovermode = 'x'
          // }
          // eslint-disable-next-line no-undef
          Plotly.newPlot(this.chartId, data, layout, config);
        }
        else {
          if(!this.hasComboLineData) {
            this.$refs.chart.layout.yaxis2.titlefont.color = 'transparent';
            this.$refs.chart.layout.yaxis2.tickfont.color = 'transparent'; 
            this.$refs.chart.layout.yaxis2.title.font.color = 'transparent';
            //this.$refs.chart.layout.hovermode = 'x'
          }
          else {
            this.$refs.chart.layout.yaxis2.titlefont.color = '#0C2837';
            this.$refs.chart.layout.yaxis2.tickfont.color = '#0C2837'; 
            this.$refs.chart.layout.yaxis2.title.font.color = '#0C2837';
            //this.$refs.chart.layout.hovermode = layout.hovermode
          }
          //console.log(this.$refs.chart.layout, layout)
          // eslint-disable-next-line no-undef
          Plotly.newPlot(this.chartId, data, this.$refs.chart.layout, this.$refs.chart.config);
        }


        this.$refs.chart.on('plotly_hover', (hoverData) => {    
          hoverData.event.preventDefault();
          hoverData.event.stopPropagation();
          // console.log(data)   
          try {

            if(this.$refs.hoverChart) {
              const toolTipHtml = this.buildTooltip(hoverData.points[0], this.$refs.chart.data);

              const gd = this.$refs.hoverChart;
              gd.style.display = "block";
              gd.innerHTML = toolTipHtml;

              let pn = hoverData.points[0].pointNumber;
              colors[pn] = "#0C2837";
              let update = {'marker': {color: colors}};
              // eslint-disable-next-line no-undef
              Plotly.relayout(this.$refs.chart, update, 0);
            }
          }
          catch(error) {
            console.error(error)
          }
        });
        this.$refs.chart.on('plotly_unhover', (hoverData) => {          
          try {

            if(this.$refs.hoverChart) {
              let pn = hoverData.points[0].pointNumber;       
              colors[pn] = "transparent";
              let update = {'marker': {color: colors}};
              // eslint-disable-next-line no-undef
              Plotly.relayout(this.$refs.chart, update, 0);

              const gd = this.$refs.hoverChart;
              gd.innerHTML = '';
              gd.style.display = "none";
            }
          }
          catch(error) {
            console.error(error)
          }
        });
      }, 50)
    }
  },

  mounted(){
    this.buildChart();

    this.$root.$on(`fire-selected-date-change-events`, (type) => {
        this.handleDateChange(type)
      }
    )
  }
});
</script>

<style lang="scss">
    .tooltip-bg{
      box-shadow: 2px 1px 10px 1px rgba(199,199,199,0.76);
      border: none !important;
      width: fit-content !important;
      padding: 20px !important;
    }
    .tooltip-bg::before {
      content:"";
    }

    .tooltip-legendtext-label{
      font-weight: 400 !important;
      color: #4B5158 !important;
      margin-bottom: 5px;
      font-size: 14.22px !important;
    }
    .tooltip-legendtext-num{
      font-weight: 500 !important;
      font-size: 14.22px !important;
      margin-bottom: 10px;
      color: var(--site-font-secondary-color) !important;    
    }

    .tooltip-legendtitletext{
      text-align: left !important;
      margin-bottom: 10px;
      font-size: 14.22px !important;
      font-weight: 400 !important;
      color: #828E9A !important;
    }
    .dx-tooltip {
      position: absolute;
      color: rgb(0, 0, 0);
      padding: 10px;
      background: rgb(255, 255, 255);
      border-radius: 3px;
      z-index: 10000;
      flex-direction: column;
      pointer-events: none;
    }

    .dx-tooltip-pipe {
      align-self: center;
      margin-right: 5px;
      width: 20px;
      margin-bottom: 30px;
      height: 20px;
      border-radius: 2px;
      background-color: var(--site-font-chart-color);
      clip-path: circle(30%);
    }
    .regression-marker{
      align-self: center;
      margin-right: 5px;
      width: 15px;
      margin-bottom: 30px;
      height: 3px;
      border-radius: 2px;
      background-color: unset !important;
      background: repeating-linear-gradient(to right, black 0, black 5px, transparent 5px, transparent 7px);
    }

    .dx-tooltip-label {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
  .wy-panel-line-column-chart {
    position: relative;

    // .xtick {
    //   text {
    //     font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    //   }
    // }
    g.yaxislayer-above .ytick text {
      font-size: 0.55vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    g.xaxislayer-above .xtick text{
      font-size: 0.55vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    g.overaxes-above .xy2-y .y2tick text{
      font-size: 0.55vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    .hoverlayer {
      display: none;
    }
    
    .legendtext {
      font-size: 0.55vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    rect.rangeslider-slidebox {
      cursor: grab !important;
    }
    .cursor-ew-resize, .cursor-w-resize, .cursor-e-resize {
      cursor: default !important;
    }
    rect.nsewdrag.drag.cursor-ew-resize {
      cursor: default !important;
    }
    .cursor-crosshair {
      cursor: default !important;
    }
    rect.rangeslider-mask-min, rect.rangeslider-mask-max {
      fill: #888888 !important;
      fill-opacity: 0.5 !important;
    }
  }
  .wy-panel-line-column-chart.js-plotly-plot .plotly .cursor-ns-resize {
    cursor: pointer !important;
  }

  @media screen and (max-width: 1400px) {
    .wy-panel-line-column-chart {
      g.yaxislayer-above .ytick text {
        font-size: 0.85vw !important;
      }
      g.xaxislayer-above .xtick text{
        font-size: 0.85vw !important;
      }
      g.overaxes-above .xy2-y .y2tick text{
        font-size: 0.85vw !important;
      }
      .legendtext {
        font-size: 0.85vw !important;
      }
    }
  }
</style>